export function smartSplit(str, delim, limit) {
    let strSplit = str.split(delim);
    if (limit == null) {
        return strSplit;
    }
    else if (strSplit.length > limit) {
        strSplit = strSplit.slice(0, limit - 1).concat(strSplit.slice(limit - 1).join(delim));
    }
    return strSplit;
}
export function parseUrl(url) {
    //url = removeProto(url)
    var out = {};
    var protoIndex = url.indexOf("://");
    if (protoIndex >= 0) {
        out.proto = url.slice(0, protoIndex);
        url = url.slice(protoIndex + 3);
    }
    var pathAndQuery = smartSplit(url, "?", 2);
    var path = pathAndQuery[0];
    if (pathAndQuery.length > 1) {
        out.args = pathAndQuery[1];
    }
    var splitPath = smartSplit(path, "/", 4);
    if (splitPath.length > 0 && splitPath[0])
        out.host = splitPath[0]; //before first slash:  www.foobar.com/
    if (splitPath.length > 1)
        out.db = splitPath[1];
    if (splitPath.length > 2)
        out.table = splitPath[2];
    if (splitPath.length > 3) {
        var idsplit = smartSplit(splitPath[3], ":", 2);
        if (idsplit.length > 1) {
            out.id = idsplit[0];
            out.subobjectpath = idsplit[1];
        }
        else {
            out.id = splitPath[3];
        }
    }
    return out;
}
export function isCorrectPath(path, condition) {
    if (typeof (condition) === "string") {
        condition = condition.toLowerCase().trim();
        let doubleWildcardIndex = condition.indexOf("/**/");
        if (doubleWildcardIndex >= 0) {
            if (condition.substr(0, doubleWildcardIndex) != path.substr(0, doubleWildcardIndex)
                || (path.length > doubleWildcardIndex && path.charAt(doubleWildcardIndex) != "/")) {
                return false;
            }
            const startIndex = doubleWildcardIndex + "/**/".length;
            path = path.substr(startIndex);
            condition = condition.substr(startIndex);
        }
        let wildcardIndex = condition.indexOf("*");
        if (wildcardIndex < 0) { //exact match
            return condition === path;
        }
        else if (wildcardIndex >= 0) { // "path/*"
            do {
                let beforeWildcard = condition.slice(0, wildcardIndex);
                let charAfterWildcard = wildcardIndex < condition.length - 1 ? condition[wildcardIndex + 1] : null;
                if (path.indexOf(beforeWildcard) != 0)
                    return false;
                path = path.slice(beforeWildcard.length);
                if (charAfterWildcard != null) {
                    let indexOfCharAfterWC = path.indexOf(charAfterWildcard);
                    path = path.slice(indexOfCharAfterWC);
                }
                condition = condition.slice(wildcardIndex + 1);
                wildcardIndex = condition.indexOf("*");
            } while (wildcardIndex != -1);
            if (condition.length == 0)
                return true; //nothing after wildcard
            if (path.indexOf(condition) == path.length - condition.length)
                return true;
            return false;
        }
    }
    else if (Array.isArray(condition)) {
        for (let j = 0; j < condition.length; j++) {
            if (typeof condition[j] === 'string' && condition[j][0] == '~') {
                if (isCorrectPath(path, condition[j].slice(1))) {
                    return false;
                }
            }
            let correct = isCorrectPath(path, condition[j]);
            if (correct)
                return true;
        }
        return false;
    }
    throw new Error("error - invalid condition: " + condition);
    return false;
}
//# sourceMappingURL=utils.js.map